export default {
  attributes: {
    'Users.email': 'email',
  },
  messages: {
    'error.not_unique': 'An account already exists with this email address',
  },
};
